import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateUniformRequest extends BaseUpdateRequest {
    name = '';
    description = '';
}